import React, { Component } from 'react';
import axios from 'axios';
import theme from "../../../Theme/theme"
import Spinner from '../../../components/LoadingSpinner'
import { API_URL, ERROR_HANDLE } from '../../../config/constants';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "./style.css";
import PromptTiles from './PromptTiles/promptTiles';
import { SegmentedControl } from 'segmented-control'

const SEE_USER_SUBSET = "See User Subset:";
const AGE_RANGE = "Age Range"
const TIME_RANGE = "Select Time Range"
const TIME_RANGE_ERROR_NOTE = "Please select valid date range";
const NO_TILES_DESCRIPTION = "No Data Available";
const POST_WORKOUT_DATA = "POST \n\n WORK \n\n DATA";
const CALENDAR_IMAGE = require('../../../assets/images/dynamicPricing/calendar_icon.png');
const TIMER_IMAGE = require('../../../assets/images/dynamicPricing/timer_icon.png');
const GRAPH_INNER_IMAGE = require('../../../assets/images/dynamicPricing/graph_inner.png');
const GRAPH_OUTER_IMAGE = require('../../../assets/images/dynamicPricing/graph_outer.png');
const TABLE_COLUMN_HEADER = [" ", "Over Past Day", "Daily Average"];
const TABLE_ROW_HEADER = ["Duration", "Spending", "Gym Visits", "Referrals"];
const timeFilter = {
    DAY: "Day",
    WEEK: "Week",
    MONTH: "Month",
    YEAR: "Year",
    ALL: "All",
}
const userFilter = {
    ALL_USERS: "ALL USERS",
    MALE: "Male",
    FEMALE: "Female"
}
const promptTilesDataVisualizeType = {
    PERCENTAGE: "PERCENTAGE",
    MINUTES: "MINUTES",
    COUNTS: "COUNTS"
}

class PostWorkoutData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            promptTiles: [],
            isLoading: true,
            lowerAgeLimit: 0,
            upperAgeLimit: 99,
            analyticsData: {},
            selectedTimeFilter: timeFilter.ALL,
            selectedUserFilter: userFilter.ALL_USERS,
            startDate: "",
            endDate: "",
            showDateRangeError: false,
            activeDataVisualizeType: promptTilesDataVisualizeType.PERCENTAGE //Default activeDataVisualizeType is minutes
        };
    };

    componentDidMount() {
        this.getPromptTilesApiCall();
    }

    getPromptTilesApiCall() {
        let promptTilesUrl = `/admin/analytics/promptTiles`;
        if (this.state.startDate && this.state.endDate) {
            promptTilesUrl += `?from=${new Date(this.state.startDate).toISOString()}&to=${new Date(this.state.endDate).toISOString()}`
        }
        const access_token = localStorage.getItem('access_token');
        axios
            .get(`${API_URL}${promptTilesUrl}`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                if (!res.error) {
                    this.setState({
                        promptTiles: res.data
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    getTilesTotalCount() {
        let tilesTotalCount = 0;
        this.state.promptTiles && this.state.promptTiles.forEach((promptTilesItem) => {
            tilesTotalCount = tilesTotalCount + promptTilesItem.count;
        });
        return tilesTotalCount;
    }

    getTilePercentage(totalCount, count) {
        return ((count * 100) / totalCount).toFixed(0);
    }

    getPrompTilesDataToDisplay(count, minutes) {
        const totalCount = this.getTilesTotalCount();
        switch (this.state.activeDataVisualizeType) {
            case promptTilesDataVisualizeType.COUNTS:
                return count ? count : 0;
            case promptTilesDataVisualizeType.PERCENTAGE:
                return this.getTilePercentage(totalCount, count) + "%";
            default:
            case promptTilesDataVisualizeType.MINUTES:
                return minutes ? minutes : 0;
        }
    }

    renderPromptTiles = () => {
        let promptTilesArray = [];
        //sort prompt tiles based on the percentage
        this.state.promptTiles.sort((a, b) => { return b.count - a.count });
        this.state.promptTiles && this.state.promptTiles.forEach((promptTilesItem, index) => {
            promptTilesArray.push(
                <div key={"promptTiles" + index} style={style.promptTiles}>
                    <div key={"promptTilesPercentage" + index} style={style.promptTilesPercent}>{this.getPrompTilesDataToDisplay(promptTilesItem.count, promptTilesItem.minutes)} </div>
                    <div style={style.promptTilesBox}>
                        <div key={"promptTilesText" + index} style={style.promptTilesText}>{promptTilesItem.name.toUpperCase()} </div>
                        <div style={style.promptTileIconContainer}>
                            <img src={promptTilesItem.icon} alt="" style={style.promptTilesIcon} />
                        </div>
                    </div>
                </div>
            );
        });
        if (promptTilesArray.length === 0) {
            promptTilesArray.push(
                <div key={"NoPromptTilesText"} style={style.noTilesText}>{NO_TILES_DESCRIPTION}</ div>
            )
        }
        return (
            <div style={style.promptTilesContainer}>
                {promptTilesArray}
            </div>);
    }

    updateSelectedUserFilter(value) {
        this.setState({
            selectedUserFilter: value
        })
    }

    updateSelectedTimeFilter(value) {
        let dayCount;
        switch (value) {
            case timeFilter.DAY:
                dayCount = 1;
                break;
            case timeFilter.WEEK:
                dayCount = 7;
                break;
            case timeFilter.MONTH:
                dayCount = 30;
                break;
            case timeFilter.YEAR:
                dayCount = 365;
                break;
            case timeFilter.ALL:
            default:
                dayCount = 0
        }
        this.setState({
            startDate: dayCount ? moment().subtract(dayCount, 'days') : "",
            endDate: dayCount ? moment() : "",
            selectedTimeFilter: value
        }, () => this.getPromptTilesApiCall())
    }

    handleStartDateChange(date) {
        //update the start date only if it is less than or equal to end date and future date.
        !moment(date).isAfter(this.state.endDate) && !moment(date).isAfter(new Date()) ?
            this.setState({
                startDate: date,
                showDateRangeError: false
            }, () => this.getPromptTilesApiCall()) :
            this.setState({
                showDateRangeError: true
            })
    }

    handleEndDateChange(date) {
        //update the end date only if it is greater than or equal to start and less than or equal to future date.
        !moment(date).isBefore(this.state.startDate) && !moment(date).isAfter(new Date()) ?
            this.setState({
                endDate: date,
                showDateRangeError: false
            }, () => this.getPromptTilesApiCall()) :
            this.setState({
                showDateRangeError: true
            })
    }

    renderDateFilter() {
        let timeFilterComponent = [];
        timeFilterComponent.push(Object.keys(timeFilter).map((filter, index) => {
            const filterText = Object.keys(timeFilter).length === index + 1 ? timeFilter[filter] : timeFilter[filter] + " - "
            const filterTextStyle = timeFilter[filter] === this.state.selectedTimeFilter ? { ...style.filterText, ...{ fontWeight: theme.fontWeight.bold } } : style.filterText
            return <div key={"timeFilter" + index} style={filterTextStyle} onClick={() => this.updateSelectedTimeFilter(timeFilter[filter])}>{filterText}</div>
        }));
        return (
            <div style={{ ...style.filterContainer, ...style.flexAlignSpaceBetween }} >
                <div style={{ display: "flex", height: 250, width: "100%", justifyContent: "space-around", marginTop: 30 }}>
                    <div style={style.flexColumnWrapper}>
                        <div style={{ ...style.userFilter, ...{ fontSize: 15, marginTop: 0, borderWidth: 0, lineHeight: "30px" } }}>{TIME_RANGE} </div>
                        <DatePicker
                            locale="en-us"
                            selected={this.state.startDate}
                            onChange={(date) => this.handleStartDateChange(date)}
                        />
                        <div style={{ ...style.userFilter, ...style.timerDescription }}><span style={style.separator} />{"to"}<span style={style.separator} /></div>
                        <DatePicker
                            locale="en-us"
                            selected={this.state.endDate}
                            onChange={(date) => this.handleEndDateChange(date)}
                        />
                        {this.state.showDateRangeError && <div style={{ color: theme.color.red }}>{TIME_RANGE_ERROR_NOTE}</div>}
                    </div>
                    <div style={style.flexColumnWrapper}>
                        <img src={CALENDAR_IMAGE} alt="" style={{ height: 114, width: 77 }} />
                        <img src={TIMER_IMAGE} alt="" style={{ height: 79, width: 79 }} />
                    </div>
                </div>
                <div style={{ ...style.filterText, ...{ fontWeight: theme.fontWeight.bold, fontSize: 70, width: 250 } }}>{this.state.selectedTimeFilter.toUpperCase()}</div>
                <div style={{ ...style.flexAlignSpaceBetween, ...{ marginBottom: 25 } }} >
                    {timeFilterComponent}
                </div>
            </div>
        );
    }

    renderPanel() {
        return (
            <div style={{
                ...style.panelWrapper, ...style.flexAlignSpaceBetween
            }}>
                {this.renderDateFilter()}
                < div style={{ backgroundColor: theme.color.borderGrey, width: 23, height: "100%" }} />
                < div style={{ flexDirection: "column", paddingLeft: 32, paddingRight: 16 }}>
                    <div style={style.imageContainer}>
                        <img src={GRAPH_OUTER_IMAGE} alt="" style={{ position: "absolute", height: 87, width: 134 }} />
                        <img src={GRAPH_INNER_IMAGE} alt="" style={{ height: 57, width: 100, marginLeft: 25, marginTop: 10 }} />
                    </div>
                    <div style={style.panelText}>{POST_WORKOUT_DATA}</div>
                </div >
            </div >
        );
    }

    renderTableBody() {
        return TABLE_ROW_HEADER.map((rowHeader, rowIndex) => {
            return (<tr key={"tableRow" + rowIndex}>
                {
                    TABLE_COLUMN_HEADER.map((columnHeader, columnIndex) => {
                        return <td key={"row-value" + rowIndex + columnIndex}>
                            {
                                columnIndex === 0 ? <div style={{ ...style.rowHeader, ...{ height: 85, lineHeight: "100px", verticalAlign: "bottom" } }}>{rowHeader}</div> :
                                    <div>
                                        <div style={{ ...style.rowHeader, ...{ fontSize: 17, marginLeft: 20, marginRight: 20 } }}>{columnHeader}</div>
                                        <div style={{ ...style.rowHeader, ...{ fontSize: 27, margin: 20, marginTop: 10, marginBottom: 15 } }}>{"123:12"}</div>
                                    </div>
                            }
                        </td>
                    })
                }
            </tr>
            )
        });
    }

    updateLowerAge = (age) => {
        age >= 0 && age <= this.state.upperAgeLimit && this.setState({
            lowerAgeLimit: age
        });
    }

    updateUpperAge = (age) => {
        age >= this.state.lowerAgeLimit && age <= 99 && this.setState({
            upperAgeLimit: age
        });
    }

    renderUserFilter() {
        let userFilterComponent = [];
        userFilterComponent.push(Object.keys(userFilter).map((filter, index) => {
            let filterStyle = index === 0 ? { ...style.userFilter, ...{ width: "100%", marginTop: 33 } } : style.userFilter
            filterStyle = this.state.selectedUserFilter === userFilter[filter] ? { ...filterStyle, ...{ backgroundColor: theme.color.primaryBlue, color: theme.color.white } } : filterStyle
            return <div key={"userFilter" + index} style={filterStyle} onClick={() => this.updateSelectedUserFilter(userFilter[filter])}>{userFilter[filter]}</div>
        }));
        return (
            <div style={style.flexAlignSpaceBetween}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <div style={{ ...style.promptTilesPercent, ...{ width: 200, marginTop: 34 } }}>{SEE_USER_SUBSET} </div>
                    <div style={{ ...style.flexAlignSpaceBetween, ...{ width: 240, flexWrap: 'wrap' } }}>
                        {userFilterComponent}
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <div style={{ ...style.userFilter, ...{ borderWidth: 0, width: 150, marginTop: 45 } }}>{AGE_RANGE} </div>
                    <div style={style.flexAlignSpaceBetween}>
                        <div style={style.rowHeader} onClick={() => this.updateLowerAge(this.state.lowerAgeLimit - 1)} >{"-  "}</div>
                        <div style={{ ...style.userFilter, ...{ width: 40 } }}>{this.state.lowerAgeLimit} </div>
                        <div style={style.rowHeader} onClick={() => this.updateLowerAge(this.state.lowerAgeLimit + 1)} >{"  +"}</div>
                    </div>
                    <div style={style.flexAlignSpaceBetween}>
                        <div style={style.rowHeader} onClick={() => this.updateUpperAge(this.state.upperAgeLimit - 1)} >{"-  "}</div>
                        <div style={{ ...style.userFilter, ...{ width: 40 } }}>{this.state.upperAgeLimit}</div>
                        <div style={style.rowHeader} onClick={() => this.updateUpperAge(this.state.upperAgeLimit + 1)} >{"  +"}</div>
                    </div >
                </div >
            </div >
        );
    }

    renderSegmentControl() {
        return <SegmentedControl
            name="promptTilesVisualizeData"
            options={[
                { label: promptTilesDataVisualizeType.PERCENTAGE, value: promptTilesDataVisualizeType.PERCENTAGE },
                { label: promptTilesDataVisualizeType.MINUTES, value: promptTilesDataVisualizeType.MINUTES, default: true },
                { label: promptTilesDataVisualizeType.COUNTS, value: promptTilesDataVisualizeType.COUNTS }
            ]}
            setValue={newValue => {
                this.setState({
                    activeDataVisualizeType: newValue
                })
            }}
            style={style.segmentControl}
        />
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                <div style={style.wrapper}>
                    <div style={{ display: "flex" }}>
                        <div style={style.tableWrapper}>
                            <div style={{ ...style.tableContainer, ...style.flexColumnWrapper }}>
                                {
                                    Object.keys(this.state.analyticsData).length > 0 && <table>
                                        <tbody>
                                            {this.renderTableBody()}
                                        </tbody>
                                    </table>
                                }
                                {this.renderSegmentControl()}
                                {this.renderPromptTiles()}
                            </div>
                        </div>
                        {this.renderPanel()}
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", width: "90%" }}>
                        {/* {this.renderUserFilter()}
                        <PromptTiles /> */}
                    </div>
                </div >
        );
    }
}

const style = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        paddingBottom: '75px',
        flexDirection: 'column',
        alignItems: 'center',
    },
    flexAlignSpaceBetween: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center'
    },
    flexColumnWrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },
    tableWrapper: {
        alignItems: 'center',
        borderRadius: 15,
        backgroundColor: theme.color.textLightWhite,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        paddingLeft: 6,
        paddingRight: 20,
        paddingTop: 13,
        paddingBottom: 36,
        zIndex: 1
    },
    panelWrapper: {
        borderRadius: 15,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        marginTop: 40,
        marginBottom: 40,
        marginLeft: -10,
        height: 480,
        width: 600,
        backgroundColor: theme.color.backgroundGrey
    },
    filterContainer: {
        backgroundColor: theme.color.textLightWhite,
        width: 380,
        height: "100%",
        flexDirection: "column",
        marginRight: 25,
        marginLeft: 10
    },
    imageContainer: {
        height: 87,
        width: 134
    },
    tableContainer: {
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 32,
        paddingRight: 22,
        borderRadius: 15,
        minHeight: 480,
        width: 480,
        boxShadow: "0 0 10px 0 inset " + theme.color.lightShadowColor
    },
    rowHeader: {
        fontSize: 25,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        whiteSpace: "pre-wrap"
    },
    panelText: {
        fontSize: 30,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.textLightWhite,
        textAlign: 'center',
        whiteSpace: "pre-wrap",
        marginTop: 50,
        width: 150
    },
    filterText: {
        fontSize: 18,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.regular,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        whiteSpace: "pre-wrap"
    },
    promptTilesContainer: {
        display: "flex",
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    promptTiles: {
        width: 90,
        marginBottom: 15,
        marginHorizontal: 8
    },
    promptTilesBox: {
        height: 80,
        width: 80,
        backgroundColor: theme.color.primaryBlue,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column-reverse",
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: theme.black,
        shadowOffset: { width: 1, height: 1 },
        shadowOpacity: 0.5,
        shadowRadius: 2,
        elevation: 1
    },
    promptTileIconContainer: {
        width: "60%",
        height: "60%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    promptTilesIcon: {
        maxWidth: "100%",
        maxHeight: "100%"
    },
    promptTilesPercent: {
        fontSize: 21,
        fontFamily: theme.font.glacialIndifference,
        fontStyle: theme.fontWeight.regular,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.thickGrey,
        textAlign: 'center',
        width: 80,
        marginBottom: 4
    },
    promptTilesText: {
        fontSize: 9,
        fontFamily: theme.font.glacialIndifference,
        fontStyle: theme.fontWeight.regular,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.white,
        textAlign: 'center',
        marginTop: 2,
        height: 20,
        display: "flex",
        alignItems: "center",
        paddingLeft: 2,
        paddingRight: 2
    },
    noTilesText: {
        fontSize: 20,
        fontFamily: theme.font.glacialIndifference,
        fontStyle: theme.fontWeight.regular,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.thickGrey,
        textAlign: 'center'
    },
    userFilter: {
        fontSize: 25,
        fontFamily: theme.font.avenirMediumOblique,
        color: theme.color.thickGrey,
        textAlign: 'center',
        borderRadius: 8,
        border: "1px solid " + theme.color.tableSeparatorGrey,
        paddingLeft: 20,
        paddingRight: 20,
        marginTop: 12,
        lineHeight: "40px"
    },
    timerDescription: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        borderWidth: 0,
        width: 150,
        marginTop: 0,
        lineHeight: "20px"
    },
    separator: {
        width: 10,
        height: 1,
        backgroundColor: theme.color.thickGrey,
        display: "inline-block",
        marginRight: 4,
        marginLeft: 4
    },
    segmentControl: {
        width: 350,
        height: 50,
        color: theme.color.thickGrey,
        borderRadius: 10,
        marginBottom: 50
    }
}

export default PostWorkoutData;
